import Tooltip from '@/components/tooltip';
import { BENEFICIARY_AVAILABLE_DETAILS, BeneficiaryDetailTabLabels } from '@/modules/beneficiary/entities/constants';
import { useBillingModel } from '@/modules/billing/hooks/useBillingModel';
import { useHistoryLocation, useHistoryNavigator } from '@/navigation';
import React, { useMemo } from 'react';
import { Button, Tabs } from 'vkit/lib/components';
import { Grid, Row } from 'vkit/lib/context';

interface BeneficiaryDetailsActionsProps {
  isLoading?: boolean;
  isHolder?: boolean;
  showUpdateAndRemoveActions?: boolean;
  disableRemoveAction?: boolean;
  disableUpdateAction?: boolean;
  currentTab: number;
  setCurrentTab: (tab: number) => void;
}

const BeneficiaryDetailsActions: React.FC<BeneficiaryDetailsActionsProps> = ({
  isLoading,
  isHolder,
  showUpdateAndRemoveActions,
  disableUpdateAction,
  disableRemoveAction,
  currentTab,
  setCurrentTab,
}) => {
  const navigate = useHistoryNavigator();
  const { pathname } = useHistoryLocation();
  const { isCompanyFeeForLife, isCompanyFeeForService } = useBillingModel();

  const baseUrl = pathname.replace('/details', '');

  const tooltipMessage = disableRemoveAction
    ? 'Este beneficiário não pode ser excluído pois está cancelado ou em processamento.'
    : '';

  const tabsToRender = useMemo(() => {
    if (isLoading) {
      return [];
    }
    return BENEFICIARY_AVAILABLE_DETAILS.filter((tab) => {
      if (
        (isHolder && tab.label === BeneficiaryDetailTabLabels.HOLDER) ||
        (!isHolder && tab.label === BeneficiaryDetailTabLabels.DEPENDENTS)
      ) {
        return false;
      }

      return !(tab.label === BeneficiaryDetailTabLabels.BENEFIT && isCompanyFeeForLife);
    }).map((tab) => ({
      ...tab,
      active: tab.index === currentTab,
    }));
  }, [currentTab, isCompanyFeeForLife, isHolder, isLoading]);

  return (
    <Row style={{ padding: 0 }}>
      <Grid alignContent='justify' gap={24} alignItems='center'>
        <Tabs iconDir='left' elements={[]} actions={tabsToRender} onChange={selectedTabIndex => {
          const tab = tabsToRender[selectedTabIndex];
          setCurrentTab(tab.index)
        }} />

        <Row style={{ padding: '10px 0 0' }}>
          {showUpdateAndRemoveActions && !isLoading && isCompanyFeeForService && (
            <Grid gap={24} alignContent='right'>
              <Button
                disabled={disableUpdateAction}
                label='Solicitar alteração de beneficiário'
                onClick={() => navigate.push(`${baseUrl}/update`)}
                solo
                outlined
              />
              <Tooltip title={tooltipMessage}>
                <Button
                  disabled={disableRemoveAction}
                  label='Solicitar exclusão de beneficiário'
                  onClick={() => navigate.push(`${baseUrl}/removal`)}
                  color='danger'
                  outlined
                />
              </Tooltip>
            </Grid>
          )}
        </Row>
      </Grid>
    </Row>
  );
};

export default BeneficiaryDetailsActions;
